import { render, staticRenderFns } from "./e404.vue?vue&type=template&id=3acc5172&"
import script from "./e404.vue?vue&type=script&lang=js&"
export * from "./e404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports